export const BIN_REGEX = /^[0-9]{12}$/
export const EMAIL_REGEX = /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
export const PHONE_REGEX = /\+[0-9] \([0-9]{3}\) [0-9]{3} - [0-9]{2} - [0-9]{2}/
export const DOCUMENT_NUMBER_REGEX = /^[0-9]{7}/
export const IIN_REGEX = /^[0-9]{12}$/
